import styled from 'styled-components';

export const CancellationPolicyList = styled.ul(
  props => `
    padding: ${props.theme.spacing.xlarge};
    border-top: 2px solid ${props.theme.colors.goBrandBlue.light}
    list-style-type: none;
  `,
);

export const CancellationPolicyListItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large} 0;
    list-style-type:none;
  `,
);

export const CancellationItemText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(16)};
    padding: 0 0 0 ${props.theme.spacing.base};
  
    /* font idiosyncrasies */
    position: relative;
    top: -3px;
  `,
);

export const CancellationPolicyLoaderContainer = styled.div(
  props => `
    padding: ${props.theme.spacing.large};
  `,
);

export const CancellationPolicyListLoaderSmallItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large} 0;
    list-style-type:none;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width:30rem;
    margin-bottom :${props.theme.spacing.base};
  
  `,
);

export const CancellationPolicyListLoaderLargeItem = styled.li(
  props => `
    padding: 0 0 ${props.theme.spacing.large} 0;
    list-style-type:none;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width:40rem;
    margin-bottom :${props.theme.spacing.base};
  
  `,
);

export const PolicyContentContainer = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    width:100%;
    max-height: 80vh;
    overflow: auto;
    `,
);

export const CancellationPolicyErrorText = styled.span(
  props => `
      color: ${props.theme.colors.goRed.base};
    `,
);
